<template>
    <div class="contacts" :class="{loading: loading}">
        <fieldset>
            <legend class="no-margin">
                <div class="row">
                    <div class="col-sm-6 col-md-7 text-right form-group pull-sm-right">
                        Contacts
                    </div>
                    <div class="col-sm-6 col-md-5 form-group align-sm-left" v-if="canCreate">
                        <button type="button" class="btn btn-success" @click="open(null)">
                            Create Contact
                        </button>
                    </div>
                </div>
            </legend>

            <div class="form-group text-right">
                <div class="checkbox">
                    <label>
                        <input v-model.boolean="archived"
                               type="checkbox"
                               id="archived"
                               name="archived">
                        Show Archived
                    </label>
                </div>
            </div>

            <div class="list-group">
                <a href="javascript://void(0)" class="list-group-item"
                   v-for="contact in models"
                   :class="{'list-group-item-success active':selectedModelId === contact.id}"
                   @click="open(contact.id)">
                    <h4>
                        {{contact.name}}
                        <span v-if="contact.archivedLabel"
                              v-html="listConcontacttact.archivedLabel"></span>
                    </h4>
                    <h5 v-if="contact.company">
                        {{contact.company.name}}
                        <span v-if="contact.title">- {{contact.title}}</span>
                    </h5>
                </a>
            </div>
        </fieldset>

        <contact @afterSave="afterSave" ref="contactComponent"
                 :company-ids="companyIds"
                 :model-id="selectedModelId">
            &nbsp;
        </contact>
    </div>
</template>

<script>
    import models from "./mixins/models";

    export default {
        mixins: [ models ],

        props: {
            companyIds: {
                required: true,
                type: Array,
            },

            canCreate: {
                default: false,
                type: Boolean
            },
        },

        computed: {
            contacts(){
                return this.models;
            },

            url(){
                return '/api/contacts?company_ids=' + encodeURI( this.companyIds );
            },

            modelComponent(){
                return 'contactComponent';
            },

            resourceKey(){
                return 'Contacts';
            },
        },
    }
</script>
